module.exports = __webpack_public_path__ + "static/media/awsIcon.c1833df7.svg";